import { createContext } from 'react'

export const UserProfileContext = createContext<any>({})
export const SampleDataContext = createContext<any>({})
